export default {
  baseUrl: 'http://robohotel.volhinsoft.ru',
  accessToken: localStorage.getItem("RobohotelAdminAccessToken") || null,
  requestCancellers: {},
  canAccommodateGuests: localStorage.getItem("RobohotelAdminUserAccommodateGuests") || false,
  canEditStructureHotels: localStorage.getItem("RobohotelAdminUserEditStructureHotels") || false,
  timezone: null,
};
